<template>
  <div class="retrieve">
    <div class="forget-box">
      <van-nav-bar @click-right="goHome">
        <template #left>
          <div class="left-text">
            <div class="logo">
              <img
                class="auto-img"
                src="../assets/images/home_active.png"
                alt=""
              >
            </div>
            <div class="logo-title">Luckin Coffce</div>
          </div>
        </template>
        <template #right>
          <div class="close-box">先逛一逛</div>
        </template>
      </van-nav-bar>
      <div class="login-form">
        <div class="title">忘记密码!</div>
        <div class="en-title">Forget the password</div>

        <div class="login-form-box">
          <van-form>
            <van-field
              label="手机号："
              class="list"
              placeholder="手机号"
              v-model="userInfo.phone"
            />
            <van-field
              class="list"
              :type="isPassword ? 'password' : 'text'"
              label="密码："
              placeholder="密码"
              v-model="userInfo.password"
              :right-icon="isPassword ? 'closed-eye' : 'eye-o'"
              @click-right-icon="viewPassword"
            />
            <div class="login-btn">
              <van-button
                round
                block
                native-type="submit"
                color="#0C34BA"
                @click="commit"
              >提&nbsp;&nbsp;交</van-button>
            </div>
          </van-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "../assets/less/retrieve.less";
import { validForm } from "../assets/js/ValidForm";
import { utils } from "../assets/js/Utils";

export default {
  data() {
    return {
      // 登录信息
      userInfo: {
        phone: "",
        password: "",
        email: "",
        validCode: "",
      },
      isPassword: true,
      text: "发送验证码",
      isSend: false,
    };
  },

  created() {},

  methods: {
    // 去首页
    goHome() {
      this.$router.push({ name: "Home" });
    },

    // 去登录
    goLogin() {
      this.$router.push({ name: "Login" });
    },

    // 查看密码
    viewPassword() {
      this.isPassword = !this.isPassword;
    },

    // 提交
    commit() {
      // 验证修改密码表单
      let o = {
        phone: {
          value: this.userInfo.phone,
          reg: /^1[3-9]\d{9}$/,
          errorMsg: "手机格式不正确",
        },
        password: {
          value: this.userInfo.password,
          reg: /^[A-Za-z]\w{5,15}$/,
          errorMsg: "密码格式不正确",
        },
      };

      if (!validForm.valid(o)) {
        // 验证不通过
        return;
      }

      // 发起忘记密码请求
      // 验证通过
      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
        loadingType: "spinner",
      });

      // 序列化参数
      let data = utils.queryString({
        appkey: this.appkey,
        phone: this.userInfo.phone,
        password: this.userInfo.password,
      });

      this.axios({
        method: "POST",
        url: "/retrievePassword",
        data,
      })
        .then((result) => {
          this.$toast.clear();

          if (result.data.code == "L001") {
            setTimeout(() => {
              this.$router.push({ name: "Login" });
            }, 800);
          } else {
            this.$toast(result.data.msg);
          }
        })
        .catch((err) => {
          this.$toast.clear();
        });
    },
  },
};
</script>
